import { apiClient } from '_app'
import { CancelToken } from 'axios'
import { ApiResponse } from 'dtos'
import { OutboundTransporterCompanyDto } from 'dtos/companies'
import { URIQuery } from 'utils'

const baseUrl = (): string => '/api/outbound-transporter-companies'

export const getOutboundTransporterCompanies = (outboundTripGuid?: string, cancelToken?: CancelToken) =>
  apiClient.get<ApiResponse<OutboundTransporterCompanyDto[]>>(baseUrl() + URIQuery({ outboundTripGuid }), { cancelToken }).then(res => res.data)
